import * as Sentry from "@sentry/react";
import axios from "axios";
import { initializeEcho, setupAutoReconnect } from "./lib/echo";

window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.global = window;

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
    enabled: import.meta.env.VITE_SENTRY_ENABLED === "true",
});

// Initialize Laravel Echo for WebSocket support
const echo = initializeEcho();
if (echo) {
    // Setup automatic reconnection with exponential backoff
    setupAutoReconnect();

    // Make Echo available globally for components
    window.Echo = echo;
}
